import { render, staticRenderFns } from "./TongBi.vue?vue&type=template&id=e181609e&scoped=true&"
import script from "./TongBi.vue?vue&type=script&lang=js&"
export * from "./TongBi.vue?vue&type=script&lang=js&"
import style0 from "./TongBi.vue?vue&type=style&index=0&id=e181609e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e181609e",
  null
  
)

export default component.exports